import { Box, Grid } from "@mui/material";
import RentTable from "../../components/Fleet/RentTable/RentTable";
import RentPopup from "../../components/Fleet/RentPopup/RentPopup";

const RentPage = () => {
  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <RentPopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <RentTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RentPage;
